<template>
  <div :id="this.idd" class="flip-counter-wrapper"></div>
</template>

<script>
import FlipClock from 'flipclock';
import 'flipclock/dist/flipclock.css';

export default {
  props: {
    idd: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const el = document.getElementById(this.idd);
    var currentDate = new Date();
    currentDate.setMinutes(currentDate.getMinutes() + 8);
    const clock = new FlipClock(el, currentDate, {
      face: 'MinuteCounter',
      showSeconds: true,
      countdown: true,
      language: {
        years: 'Anni',
        months: 'Mesi',
        days: 'Giorni',
        hours: 'Ore',
        minutes: 'Minuti',
        seconds: 'Secondi',
      },
    });

    let x = setInterval(() => {
      let now = new Date();
      if (currentDate.getMinutes() === now.getMinutes() && now.getSeconds() === currentDate.getSeconds()) {
        setTimeout(() => {
          this.$emit('closed');
          clock.stop();
          clearInterval(x);
        }, 400);
      }
    }, 1000);
  },
};
</script>

<style scoped>
.flip-counter-wrapper {
  width: fit-content;
  margin: 20px auto;
}
.flip-counter-wrapper .flip-clock {
  font-size: 14px;
}
</style>
